var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../base/classbase.directive';
import { ClassService } from '../../service/class.service';
import { ValidationService } from '../../service/validation.service';
var AddRowDirective = /** @class */ (function (_super) {
    __extends(AddRowDirective, _super);
    function AddRowDirective(el, renderer, service, validService) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.validService = validService;
        _this.err_p = _this.renderer.createElement('p');
        _this.err_valid = [];
        return _this;
    }
    AddRowDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    AddRowDirective.prototype.onInit = function () {
    };
    AddRowDirective.prototype.addRequiredError = function (errFlg, msg) {
        var element = this.el.nativeElement;
        var el = element.querySelector('.formError:not(.formValidationError)');
        if (errFlg) {
            if (!el) {
                this.err_text = this.renderer.createText(msg);
                this.renderer.addClass(this.err_p, 'formError');
                this.renderer.appendChild(this.err_p, this.err_text);
                this.renderer.appendChild(element, this.err_p);
            }
        }
        else {
            if (el) {
                this.renderer.removeChild(this.err_p, this.err_text);
                this.renderer.removeChild(element, this.err_p);
            }
        }
    };
    AddRowDirective.prototype.addValidationError = function (error, targetComponents, componentName) {
        var msgs = [];
        if (typeof error.validationError !== 'undefined' && typeof error.validationError[componentName] !== 'undefined' && (targetComponents.length === 0 || targetComponents.indexOf(componentName) >= 0)) {
            msgs = error.validationError[componentName];
        }
        for (var _i = 0, _a = this.err_valid; _i < _a.length; _i++) {
            var err_v = _a[_i];
            this.renderer.removeChild(err_v.p, err_v.text);
            this.renderer.removeChild(this.el.nativeElement, err_v.p);
        }
        this.err_valid = [];
        for (var _b = 0, msgs_1 = msgs; _b < msgs_1.length; _b++) {
            var msg = msgs_1[_b];
            var err_p = this.renderer.createElement('p');
            var err_text = this.renderer.createText(msg);
            this.renderer.addClass(err_p, 'formError');
            this.renderer.addClass(err_p, 'formValidationError');
            this.renderer.appendChild(err_p, err_text);
            this.renderer.appendChild(this.el.nativeElement, err_p);
            this.err_valid.push({ p: err_p, text: err_text });
        }
        this.validService.afterValidation();
    };
    AddRowDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[addrowDir]'
                },] }
    ];
    /** @nocollapse */
    AddRowDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService },
        { type: ValidationService }
    ]; };
    return AddRowDirective;
}(ClassBaseDirective));
export { AddRowDirective };
//# sourceMappingURL=addrow.directive.js.map